export const domainMapper = (suggest) => ({
    suggest,
    corrected: "",
    original: "",
    misspelledCount: 0
});
